import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyle = makeStyles((theme) => ({
    container: (props) => ({
        display: 'flex',
        flexDirection: 'column',
        // justifyContent:"space-between",
        maxWidth: '100%',
        borderRadius: 10,
        // height: '100%',
        minHeight: '50vh',
        direction: 'ltr',
        position: 'relative',
        zIndex: 1,
        fontFamily: 'inherit',
        textAlign: props.rtl ? 'right' : 'left',
        [theme.breakpoints.down(1025)]: {
            minHeight: '82vh'
        }
    }),
    mobileContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    },
    dialogMobile: {
        maxHeight: '100vh',
        height: '100%',
        minWidth: '100%',
        borderRadius: '0'
        // width: '100%',
    },
    dateContainer: {
        display: 'flex',
        justifyContent: 'center',
        position: 'relative',
        // marginBottom: '32px',
        width: '200px',
        margin: '20px auto'
    },
    column: {
        display: 'flex',
        flexDirection: 'column'
    },
    wrapper: {},
    content: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        flex: 1
        // overflow:"auto"
    },
    button: {
        // borderRadius: '100px !important',
        margin: 10,
        alignSelf: 'flex-end',
        fontSize: '0.9rem'
    },
    cancelBtn: {
        // borderRadius: '100px !important',
        color: theme.palette.error.main,
        borderColor: theme.palette.error.main,
        fontSize: '0.9rem',
        background: 'white'
    },
    calender: {
        position: 'absolute',
        top: '10px',
        zIndex: 1,
        '& > div:first-child': {
            width: 'unset',
            padding: 'unset'
        }
    },
    calenderInput: {
        opacity: 0,
        padding: '6px 10px',
        width: '100%'
    },
    dateSection: {
        display: 'flex',
        padding: 16,
        paddingLeft: 116,
        '& .tether-element': {
            zIndex: '3000!important'
        },
        height: 100
    },
    input: {
        width: 150,
        height: '100px',
        margin: '0px 10px 0px 30px',
        '& p': {
            textAlign: 'right'
        },
        '& input': {
            textAlign: 'center'
        }
    },
    inputWrapper: {
        display: 'flex',
        width: '100px',
        justifyContent: 'center',
        '& div': {
            background: 'transparent',
            padding: '5px 0',
            margin: ' 0 3px'
            // borderBottom: 'solid 1.5px #ced2d6'
        },
        '& input': {
            // fontFamily: 'inherit',
            fontSize: '13px',
            fontWeight: '500',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: '1.06',
            letterSpacing: 'normal',
            textAlign: 'center',
            color: '#232733'
        }
    },
    divider: {
        margin: '0px 100px'
    },
    calenderContainer: {
        background: 'red',
        position: 'absolute'
    },
    title: {
        fontSize: '2.5rem'
    },
    actionsBar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '20px 0',
        '& > button': {
            width: '48%',
            height: '100%',
            maxWidth: '150px',
            marginInlineEnd: '13px'
        }
    },
    mobileActionsBar: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        // bottom: '20px',
        '& > button': {
            width: '48%',
            height: '100%'
        }
    },
    label: {
        textAlign: 'center'
    }
}));

export default useStyle;
